import {
  REQUEST_MAP_DRAIN_POSITIONS,
  RESPONSE_MAP_DRAIN_POSITIONS,
  REQUEST_MAP_DRAIN_POSITIONS_FAILURE,
  CLEAR_MAP_DRAIN_POSITIONS,
} from "../actions/mapDrainPositionsActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  drainsCount: 0,
  drains: [],
};

const mapDrainsPositionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MAP_DRAIN_POSITIONS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_MAP_DRAIN_POSITIONS:
      const { drains, count } = action.payload;

      return Object.assign({}, state, {
        dataState: states.READY,
        drains: drains,
        drainsCount: count,
        errors: [],
      });
    case REQUEST_MAP_DRAIN_POSITIONS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_MAP_DRAIN_POSITIONS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default mapDrainsPositionsReducer;
